export default {
  appTitle: 'Sync',
  title: 'Login',
  loginButton: 'Login',
  forgotPasswordButton: 'Forgot my password',
  signIn: {
    button: 'Sign In',
    label: '¿You still don\'t have an account?'
  },
  email: {
    inputLabel: 'Email'
  },
  password: {
    inputLabel: 'Password'
  },
  validateSuscriptionError: 'Subscription expired contact support'
}
